// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
// import '../static/js/flexible'
import 'styles/border.css'
import 'styles/reset.css'
import 'styles/common.css'

let winHeight = document.documentElement.clientHeight || document.body.clientHeight
window.winHeight = winHeight

import commonJS from '@/common/common'
window.globalConfig = commonJS.globalConfig

import serviceUtil from './utils/service'
window.serviceUtil = serviceUtil

import localStore from "./utils/localStore"
window.localStore = localStore

import utils from './utils/util'
window.utils = utils

import shareUtil from './utils/shareUtil'
window.shareUtil = shareUtil

//注入神策埋点
const tracepoint = require('./service/tracepoint')
Vue.prototype.TracePoint = tracepoint

router.beforeEach((to, from, next) => {
  document.title = to.meta.title//切换路由改变页面标题;
  next()
})

router.afterEach((to,from) => {
  Vue.nextTick(() => {
    sensors.quick("autoTrackSinglePage");
  });
});

Vue.config.errorHandler = (err, vm, info) => {
  let traceParmas={
    exception_url:window.location.href,
    exception_msg:err.stack.substring(0,500)
  }
  tracepoint.exceptionRecord(traceParmas)
}

Vue.config.productionTip = false
Vue.use(Vant)

Vue.use(Vuex)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js